<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="openData.title == '详情'"
                    label-position="left"
                    label-width="160px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item
                        label="知识库分类："
                        prop="knowledgeBaseClassification"
                    >
                        <el-select
                            v-model="formData.knowledgeBaseClassification"
                            placeholder="请选择知识库分类"
                            style="width: 100%"
                        >
                            <!-- orgList -->
                            <el-option
                                v-for="item in orgList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="知识库标题：" prop="title">
                        <el-input
                            v-model.trim="formData.title"
                            placeholder="请输入知识库标题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="知识内容：" prop="content">
                        <div v-if="openData.title == '详情'">
                            <div v-html="formData.content"></div>
                        </div>
                        <div v-else>
                            <quillEditor
                                style="width: 100%"
                                v-model="formData.content"
                            >
                            </quillEditor>
                        </div>
                    </el-form-item>

                    <el-form-item label="知识库相关标签：" prop="relevantTags">
                        <el-checkbox-group v-model="formData.relevantTags">
                            <el-checkbox
                                v-for="(city, index) in signList"
                                :label="city"
                                :key="index"
                                >{{ city }}</el-checkbox
                            >
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model.trim="formData.remark"
                            placeholder="请输入内容"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"
export default {
    props: ["openData"],
    components: {
        quillEditor,
    },
    data() {
        return {
            formData: {
                relevantTags: [],
                title: "",
                remark: "",
                content: "",
                knowledgeBaseClassification: "",
            },
            formDataRules: {
                relevantTags: [
                    {
                        required: true,
                        message: "知识库标签不能为空",
                        trigger: "blur",
                        type: "array",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "知识标题不能为空",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "知识内容不能为空",
                        trigger: "blur",
                    },
                ],
                knowledgeBaseClassification: [
                    {
                        required: true,
                        message: "知识分类不能为空",
                        trigger: "blur",
                    },
                ],
                remark: [
                    {
                        required: true,
                        message: "备注不能为空",
                        trigger: "blur",
                    },
                ],
            },
            orgList: [
                { value: "1", label: "民法典" },
                { value: "2", label: "网格化服务管理中心管理制度" },
                { value: "3", label: "物业管理条例" },
            ],
            signList: ["条例", "宣传册", "民法典时代"],
        }
    },
    created() {
        this.formData = {
            relevantTags: [],
            title: "",
            remark: "",
            content: "",
            knowledgeBaseClassification: "",
        }
        if (this.openData.title != "新增") {
            this.getData()
        }
    },
    methods: {
        // 详情获取
        getData() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/knowledgeBase/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        let jsonTemp = { ...res.content }
                        self.formData.id = jsonTemp.id
                        self.formData.title = jsonTemp.title
                        self.formData.relevantTags = jsonTemp.relevantTags.split(
                            ","
                        )
                        self.formData.knowledgeBaseClassification =
                            jsonTemp.knowledgeBaseClassification
                        self.formData.content = jsonTemp.content
                        self.formData.remark = jsonTemp.remark
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSubmit() {
            let self = this

            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (
                        this.openData.title == "新增" ||
                        this.openData.title == "编辑"
                    ) {
                        let url = ""
                        let data = { ...self.formData }
                        data.relevantTags = data.relevantTags.toString()
                        url = "/ypt/admin/knowledgeBase/info/save"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$emit("cancleAddress", true)
                                    this.$message.success(res.message)
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                    }
                }
            })
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
</style>